// src/components/UserTable.jsx
import React, { useState } from 'react';
import UserDetailPopup from './UserDetailPopup';
import { getInitials } from '../utils/initials';
import { Badge } from './ui';
import { useT } from '../i18n';
import './UserTable.css';

const messages = {
  colPerson: { tr: 'Personel', en: 'Person' },
  colGroup: { tr: 'Grup', en: 'Group' },
  options: { tr: '{n} imza seçeneği', en: '{n} signature options' },
};

const MAX_VISIBLE_GROUPS = 4;

export default function UserTable({ users }) {
  const [selectedUser, setSelectedUser] = useState(null);
  const { t } = useT(messages);

  return (
    <>
      <div className="user-table-card">
        <table className="data-table user-table">
          <thead>
            <tr>
              <th>{t('colPerson')}</th>
              <th>{t('colGroup')}</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => {
              const groups = user.groups && user.groups.length > 0 ? user.groups : [user.group].filter(Boolean);
              const visibleGroups = groups.slice(0, MAX_VISIBLE_GROUPS);
              const extraCount = groups.length - visibleGroups.length;
              return (
                <tr key={user.id} onClick={() => setSelectedUser(user)} className="clickable-row">
                  <td>
                    <div className="user-table-identity">
                      <span className="user-table-avatar">{getInitials(user)}</span>
                      <div>
                        <div className="user-table-name-row">
                          <span className="user-table-name">{user.displayName}</span>
                          {/* Sadece popup'ı açıp aşağı kaydırınca görünen
                              "Seçilebilir Şablonlar" özelliğinin var olduğunu
                              listeden de belli etsin diye — bkz. UserDetailPopup. */}
                          {user.selectable_template_count >= 2 && (
                            <Badge variant="purple" title={t('options', { n: user.selectable_template_count })}>
                              {t('options', { n: user.selectable_template_count })}
                            </Badge>
                          )}
                        </div>
                        <div className="user-table-email">{user.Mail || user.mail}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="user-table-group-pills">
                      {visibleGroups.map(g => (
                        <span className="user-table-group-pill" key={g}>{g}</span>
                      ))}
                      {extraCount > 0 && (
                        <span className="user-table-group-pill user-table-group-pill-more">+{extraCount}</span>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {selectedUser && (
        <UserDetailPopup
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
        />
      )}
    </>
  );
}
